import React, { CSSProperties, useEffect, useState } from 'react';
import { IModuleInfo } from '../../../../../redux/progress/module/moduleInterface';
import { connect } from 'react-redux';
// import { IJob, JobStatus } from '../../../../redux/progress/job/jobReducer';
import { useJobStatus } from '../../../utils/useJobStatus';
import { FormattedMessage } from 'react-intl';
import { IState } from '../../../../../redux/store';
import { IJob2, IJob2s, Job2Status } from '../../../../../redux/progress/job2/job2Interface';
import { IProgressStep } from '../../../../../redux/progress/progressSteps/progressStepReducer';
import { IFixStep } from '../../../../../redux/progress/fixProgressSteps/fixStepReducer';


class RuningAnim {
    count = 0;
    setText: ((text: string) => void) | null = null;
    creatAnim: NodeJS.Timeout | null = null;

    start(setText: (text: string) => void) {
        this.setText = setText;
        this.creatAnim = setInterval(this.handleTimeOut, 500);
    }

    handleTimeOut = () => {
        this.count++;
        if (this.count > 3) {
            this.count = 0;
        }

        let str = "正在运行";
        for (let i = 0; i < this.count; ++i) {
            str += '.';
        }
        if (this.setText)
            this.setText(str);
    }

    stop() {
        if (this.creatAnim)
            clearInterval(this.creatAnim);
    }
}

const runningAnim = new RuningAnim();


function JobStatusViewer(props: {
    activeIndex: number,
    job2s: IJob2s,
    modules: IModuleInfo[];
    mid?: string;
    flowType?: string;
    progressSteps: IProgressStep[];
    fixSteps: IFixStep[];
    styled?: CSSProperties;
}) {
    const module = props.modules[props.activeIndex];
    let job: IJob2 = {
        status: Job2Status.waiting,
        jobName: "",
        log: []
    };

    if (props.mid) {
        if (props.flowType) {
            const step = props.fixSteps.find((findStep) => {
                return findStep.mid === props.mid;
            })
            if (step) {
                job = {
                    status: step.status as number,
                    jobName: "",
                    log: []
                }
            }
        } else {
            const step = props.progressSteps.find((findStep) => {
                return findStep.mid === props.mid;
            })
            if (step) {
                job = {
                    status: step.status as number,
                    jobName: "",
                    log: []
                }
                

            }
        }

    } else if (module && props.job2s[module.PRO_MODULE_NAME]) {
        job = props.job2s[module.PRO_MODULE_NAME];
    }

    const [status, color] = useJobStatus(job);


    const [showText, setShowText] = useState(Job2Status[status].toString());

    useEffect(() => {

        setShowText(Job2Status[status].toString() == 'complete' ? '分片作业完成' : Job2Status[status].toString() == 'waiting' ? '等\xa0\xa0待' : Job2Status[status].toString() == 'error' ? '错\xa0\xa0误' : Job2Status[status].toString());
        if (status === Job2Status.running) {
            runningAnim.start(setShowText);
        } else {
            runningAnim.stop();
        }
        return () => { runningAnim.stop() };
    }, [status]);



    return (
        <FormattedMessage id={showText} >
            {(text) => {
                return (
                    <>
                        <div style={{
                            background: Job2Status[status].toString() == 'complete' ? 'rgb(83,169,255)' : color,
                            padding: '10px 10px',
                            color: '#fff',
                            borderRadius: '50%'
                        }}>{text}</div>
                    </>

                )
            }}
        </FormattedMessage>
    )

}


const mapStateToProps = (state: IState) => {
    return {
        activeIndex: state.progress.modules.activeIndex,
        job2s: state.progress.job2s,
        modules: state.progress.modules.modules,
        mid: state.progress.params.mid as string | undefined,
        flowType: state.progress.params.flowType as string | undefined,
        progressSteps: state.progress.progressStep,
        fixSteps: state.progress.fixStep,
    };
};

export default connect(
    mapStateToProps
)(JobStatusViewer);